<template>
  <div>

    <!-- Starting price -->

    <div v-for="rule in priceRules">
      <div class="price-calc-grid" v-if="rule.starting_price > 0">
        <div class="text-left"> {{ $t('pricingrules.starting_price') }}</div>
        <div> {{ parseFloat(rule.starting_price).toFixed(2) }} {{ currency_short }}</div>
      </div>

      <!-- Every started -->

      <template v-for="step in rule.steps">
        <div v-for="(price, priceIndex) in step.prices">
          <div class="price-calc-grid">
            <div class="text-left">
              <span v-if="priceIndex === 0">
                {{ $t('pricingrules.every_started') }}
                {{ formatPeriod(step.step, step.unit) }}
              </span>
              <div class="after-price" v-if="price.after">
                {{ $t('pricingrules.after') }} {{ formatPeriod(price.after, price.unit) }}
              </div>
            </div>
            <div class="price">
              {{ parseFloat(price.price).toFixed(2) }} {{ currency_short }}
            </div>
          </div>
        </div>
      </template>

      <!-- Max price -->

      <div class="price-calc-grid" v-if="rule.max_price">
        <div class="text-left"> {{ $t('pricingrules.max_price') }}</div>
        <div> {{ parseFloat(rule.max_price).toFixed(2) }} {{ currency_short }}</div>
      </div>

      <!-- Max minutes -->

      <div class="price-calc-grid" v-if="rule.max_minutes && !rule.max_time">
        <div class="text-left"> {{ $t('pricingrules.max_minutes') }}</div>
        <div> {{ formatPeriod(rule.max_minutes) }}</div>
      </div>

      <!-- Fixed end time -->

      <div class="price-calc-grid" v-if="rule.max_time">
        <div class="text-left"> {{ $t('pricingrules.max_time') }}</div>
        <div> {{ rule.max_time }}</div>
      </div>

    </div>
  </div>

</template>

<script>

export default {
  props: [
    'priceRules'
  ],
  data() {
    return {
      currency_short: process.env.CURRENCY_SHORT,
      date_time_format: 'DD.MM.YYYY HH:mm',
      minutes_in_hour: 60,
      minutes_in_day: 24 * 60
    }
  },
  methods: {
    formatPeriod(minutes, unit) {
      if (unit === 'month') {
        return `${minutes} ${this.$tc('pricingrules.month', minutes)}`;
      }
      let min = minutes;
      let days = Math.floor(min / this.minutes_in_day);
      min -= days * this.minutes_in_day;
      let hours = Math.floor(min / this.minutes_in_hour);
      min -= hours * this.minutes_in_hour;
      if (days === 1) {
        days = `${days} ${this.$tc('pricingrules.day', 1)} `;
      } else if (days > 1) {
        days = `${days} ${this.$tc('pricingrules.day', 2)} `;
      } else {
        days = '';
      }
      if (hours) {
        hours = `${hours} ${this.$t('pricingrules.hour')} `;
      } else {
        hours = '';
      }
      if (min) {
        min = `${min} ${this.$t('pricingrules.minute')} `;
      } else {
        min = '';
      }
      return (days + hours + min).trim();
    }
  }
}

</script>

<style lang="scss" scoped>

@import "~styles/app.scss";

.price-calc-grid {
  display: grid;
  grid-template-columns: 70% 30%;
  width: 250px;
  text-align: left;
  align-items: end;

  div {
    font-size: medium;
    border-bottom: 1px solid var(--grey-five);
    padding: 6px 0;
    text-align: right;
  }

  .after-price {
    border-bottom: none;
    padding: 0;
    color: grey;
  }

  div.cap {
    text-transform: capitalize;
    text-align: left;
  }

  .text-left {
    text-align: left;
  }

  .text-lower {
    text-transform: lowercase;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/pricingrules/product/PricingRulesInfo.vue